var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_1840)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_221_1840)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_221_1840",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V60H60V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_221_1840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75573 36.7479L35.3054 10.1981C37.136 8.36753 40.104 8.36753 41.9346 10.1981L36.8955 5.15906C35.0649 3.32849 32.097 3.32849 30.2664 5.15906L3.71669 31.7088C1.88611 33.5394 1.88611 36.5074 3.71669 38.3379L8.75573 43.3769C6.92515 41.5463 6.92515 38.5784 8.75573 36.7479Z",
    fill: "#EEF1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1537 18.417C51.9843 20.2476 51.9843 23.2156 50.1537 25.0462L23.6039 51.5958C21.7734 53.4264 18.8054 53.4264 16.9748 51.5958L3.71669 38.3377C1.88611 36.5071 1.88611 33.5391 3.71669 31.7085L30.2664 5.15882C32.097 3.32824 35.0649 3.32824 36.8955 5.15882L43.5247 11.788L52.9689 2.34375",
    stroke: "#405FF2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9633 31.0456C18.7631 32.4552 19.2051 33.9386 20.2894 35.0229C22.12 36.8535 25.088 36.8535 26.9186 35.0229C28.7492 33.1924 28.7492 30.2244 26.9186 28.3938C25.088 26.5632 25.088 23.5952 26.9186 21.7646C28.7492 19.934 31.7172 19.934 33.5478 21.7646C34.6321 22.8489 35.0741 24.3323 34.8739 25.7419",
    stroke: "#405FF2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9749 38.3375L20.2894 35.0229",
    stroke: "#405FF2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5476 21.7648L36.8621 18.4502",
    stroke: "#405FF2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5938 57.6562L57.6562 43.5938",
    stroke: "#FF5CF4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_221_1840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpricing);
export default __webpack_public_path__ + "static/media/expricing.a25f3d9ec3c0787a034b3e62fd2d417a.svg";
export { ForwardRef as ReactComponent };